<template>
  <MenuLayout>
    <div v-if="loading">
      <LoadingSpinner />
    </div>
    <div v-else>
      <!-- StartOF Applicant Profile行 -->
      <div ref="app_info" class="row margin-custom">
        <div class="col">
          <h4 class="fw-bold">Applicant Profile</h4>
        </div>
      </div>
      <!-- StartOFフォーム -->
      <div class="row">
        <!-- StartOF左側 -->
        <div class="col-md-6 mt-1">
          <div class="mb-1 row">
            <label class="col-md-4 col-form-label">Interview Date</label>
            <div class="col-md-8">
              <input
                v-maska:[date_mask.date_option]
                v-model="job_transactions.interview_date"
                class="form-control form-control-sm selectBorder date-box"
                disabled
              />
            </div>
          </div>
          <div class="mb-1 row">
            <label class="col-md-4 col-form-label">Name (KaNa)</label>
            <div class="col-md-8">
              <input
                type="text"
                v-model="applicants.name_jp"
                :maxlength="max_length.name_jp"
                class="form-control form-control-sm"
              />
            </div>
          </div>
          <div class="mb-1 row">
            <label class="col-md-4 col-form-label"
              >Name (English)<span class="text-danger">*</span></label
            >
            <div class="col-md-8">
              <input
                type="text"
                v-model="applicants.name_eng"
                :maxlength="max_length.name_eng"
                :class="{ 'is-invalid': error.name_eng }"
                class="form-control form-control-sm"
              />
            </div>
          </div>
          <div class="mb-1 row">
            <label class="col-md-4 col-form-label"
              >Date of Birth<span class="text-danger">*</span></label
            >
            <div class="col-md-8">
              <input
                v-maska:[date_mask.date_option]
                v-model="applicants.dob"
                v-on:input="calculateAge"
                :class="{ 'is-invalid': error.dob }"
                class="form-control form-control-sm selectBorder date-box"
                :placeholder="date_mask.placeholder"
              />
            </div>
          </div>
          <div class="mb-1 row">
            <label class="col-md-4 col-form-label">Age</label>
            <div class="col-md-8 d-flex justify-content-between">
              <input
                type="text"
                v-model="age"
                :class="{ 'is-invalid': error.age }"
                class="form-control form-control-sm age-show"
                disabled
              />
              <button
                type="button"
                v-on:click="checkApplicant"
                class="btn btn-sm btn-warning"
                title="Check in the system with name(eng) and dob"
              >
                Check Registered Applicant
              </button>
            </div>
          </div>
          <div class="mb-3 row">
            <label class="col-md-4 col-form-label">BirthPlace</label>
            <div class="col-md-4">
              <label>State</label>
              <select
                v-model="applicants.birth_state"
                v-on:change="stateChange(false)"
                class="form-select form-select-sm selectBorder"
              >
                <option selected value="">Select</option>
                <option
                  v-for="s in drop_down.brithState"
                  :key="s.id"
                  :value="s.en"
                >
                  {{ s.en }}
                </option>
              </select>
            </div>
            <div class="col-md-4">
              <label>City</label>
              <select
                v-model="applicants.birth_city"
                :disabled="!applicants.birth_state"
                :class="{ 'is-invalid': error.birth_city }"
                class="form-select form-select-sm selectBorder"
              >
                <option selected value="">Select</option>
                <option v-for="p in cityOptions" :key="p.id" :value="p.en">
                  {{ p.en }}
                </option>
              </select>
            </div>
          </div>
          <div class="mb-3 row">
            <label class="col-md-4 col-form-label">Residence Address</label>
            <div class="col-md-8">
              <textarea
                v-model="applicants.residence_address"
                cols="40"
                rows="6"
                :maxlength="max_length.residence_address"
                placeholder="Please type the residence address here..."
                class="form-control form-control-sm selectBorder"
              ></textarea>
            </div>
          </div>
          <div class="row">
            <label class="col-md-4 col-form-label">Present Address</label>
            <div class="col-md-8">
              <textarea
                v-model="applicants.present_addr"
                cols="40"
                rows="6"
                :maxlength="max_length.present_addr"
                placeholder="Please type the present address here..."
                class="form-control form-control-sm selectBorder"
              ></textarea>
            </div>
          </div>
        </div>
        <!-- EndOF左側 -->
        <!-- StartOF右側 -->
        <div class="col-md-5 mt-1">
          <div class="mb-1 row">
            <label class="col-md-6 col-form-label">Type of Occupations</label>
            <div class="col-md-6">
              <input
                type="text"
                v-model="job_transactions.occupation_type"
                class="form-control form-control-sm"
                disabled
              />
            </div>
          </div>
          <div class="mb-1 row">
            <label class="col-md-6 col-form-label"
              >Supervising Organization</label
            >
            <div class="col-md-6">
              <input
                type="text"
                v-model="job_transactions.supervision_organization"
                class="form-control form-control-sm"
                disabled
              />
            </div>
          </div>
          <div class="mb-1 row">
            <label class="col-md-6 col-form-label"
              >Implementing Organization</label
            >
            <div class="col-md-6">
              <input
                type="text"
                v-model="job_transactions.implementing_organization"
                class="form-control form-control-sm"
                disabled
              />
            </div>
          </div>
          <div class="mb-1 row">
            <label class="col-md-6 col-form-label"
              >Gender<span class="text-danger">*</span></label
            >
            <div class="col-md-6">
              <div
                v-for="(value, key) in radio.gender"
                :key="key"
                class="form-check form-check-inline"
              >
                <input
                  class="form-check-input"
                  type="radio"
                  v-model="applicants.gender"
                  :value="key"
                />
                <label class="form-check-label">{{ value }}</label>
              </div>
            </div>
          </div>
          <div class="mb-1 row">
            <label class="col-md-6 col-form-label">Height (cm)</label>
            <div class="col-md-6">
              <input
                type="number"
                v-model="applicants.height"
                id="height"
                @keypress="handleInput($event)"
                v-on:input="validateHeight"
                class="form-control form-control-sm number-col"
              />
            </div>
          </div>
          <div class="mb-1 row">
            <label class="col-md-6 col-form-label">Body Weight (kg)</label>
            <div class="col-md-6">
              <input
                type="number"
                v-model="applicants.weight"
                id="weight"
                @keypress="handleInput($event)"
                v-on:input="validateWeight"
                class="form-control form-control-sm number-col"
              />
            </div>
          </div>
          <div class="mb-1 row">
            <label class="col-md-6 col-form-label">Eyesight (Normal)</label>
            <div class="col-md-6 eye-container">
              <label class="eyeLabel">R</label>
              <select
                v-model="applicants.eyesight_r"
                class="form-select form-select-sm number-col w-50"
              >
                <option selected value="">Select</option>
                <option
                  v-for="value in drop_down.eyesight_values"
                  :key="value"
                  :value="value"
                >
                  {{ value }}
                </option>
              </select>
              <label class="eyeLabel ms-1">L</label>
              <select
                v-model="applicants.eyesight_l"
                class="form-select form-select-sm number-col w-50"
              >
                <option selected value="">Select</option>
                <option
                  v-for="value in drop_down.eyesight_values"
                  :key="value"
                  :value="value"
                >
                  {{ value }}
                </option>
              </select>
              <label class="eyeLabel ms-1">B</label>
              <select
                v-model="applicants.eyesight_botheye"
                class="form-select form-select-sm number-col w-50"
              >
                <option selected value="">Select</option>
                <option
                  v-for="value in drop_down.eyesight_values"
                  :key="value"
                  :value="value"
                >
                  {{ value }}
                </option>
              </select>
            </div>
          </div>
          <div class="mb-1 row">
            <label class="col-md-6 col-form-label">Eyesight (Glasses)</label>
            <div class="col-md-6 eye-container">
              <label class="eyeLabel">R</label>
              <select
                v-model="applicants.glass_r"
                class="form-select form-select-sm number-col w-50"
              >
                <option selected value="">Select</option>
                <option
                  v-for="value in drop_down.eyesight_values"
                  :key="value"
                  :value="value"
                >
                  {{ value }}
                </option>
              </select>
              <label class="eyeLabel ms-1">L</label>
              <select
                v-model="applicants.glass_l"
                class="form-select form-select-sm number-col w-50"
              >
                <option selected value="">Select</option>
                <option
                  v-for="value in drop_down.eyesight_values"
                  :key="value"
                  :value="value"
                >
                  {{ value }}
                </option>
              </select>
              <label class="eyeLabel ms-1">B</label>
              <select
                v-model="applicants.glass_botheye"
                class="form-select form-select-sm number-col w-50"
              >
                <option selected value="">Select</option>
                <option
                  v-for="value in drop_down.eyesight_values"
                  :key="value"
                  :value="value"
                >
                  {{ value }}
                </option>
              </select>
            </div>
          </div>
          <div class="mb-1 row">
            <label class="col-md-6 col-form-label">Blood Group</label>
            <div class="col-md-6">
              <select
                v-model="applicants.blood_type"
                class="form-select form-select-sm w-50 selectBorder"
              >
                <option selected value="">Select</option>
                <option
                  v-for="value in drop_down.blood_type"
                  :key="value"
                  :value="value"
                >
                  {{ value }}
                </option>
              </select>
            </div>
          </div>
          <div class="mb-1 row">
            <label class="col-md-6 col-form-label">Religion</label>
            <div class="col-md-6">
              <select
                v-model="applicants.religion"
                class="form-select form-select-sm selectBorder"
              >
                <option selected value="">Select</option>
                <option
                  v-for="(value, key) in drop_down.religion"
                  :key="key"
                  :value="key"
                >
                  {{ value }}
                </option>
              </select>
            </div>
          </div>
          <div class="mb-1 row">
            <label class="col-md-6 col-form-label">Race</label>
            <div class="col-md-6">
              <select
                v-model="applicants.race"
                class="form-select form-select-sm selectBorder"
              >
                <option selected value="">Select</option>
                <option v-for="r in drop_down.race" :key="r.en" :value="r.ja">
                  {{ r.en }}
                </option>
              </select>
            </div>
          </div>
          <div class="mb-1 row">
            <label class="col-md-6 col-form-label">Cell Phone</label>
            <div class="col-md-6">
              <input
                type="text"
                v-model="applicants.cellphone"
                @input="
                  applicants.cellphone = applicants.cellphone.replace(/\D/g, '')
                "
                :maxlength="max_length.cellphone"
                class="form-control form-control-sm"
              />
            </div>
          </div>
          <div class="row">
            <label class="col-md-6 col-form-label">Strength</label>
            <div class="col-md-6">
              <input
                type="text"
                v-model="applicants.strength"
                :maxlength="max_length.strength_weakness"
                class="form-control form-control-sm"
              />
            </div>
          </div>
          <div class="row">
            <label class="col-md-6 col-form-label">Weakness</label>
            <div class="col-md-6">
              <input
                type="text"
                v-model="applicants.weakness"
                :maxlength="max_length.strength_weakness"
                class="form-control form-control-sm"
              />
            </div>
          </div>
        </div>
        <!-- EndOF右側 -->
        <!-- StartOF写真側 -->
        <div class="col-md-1 mt-1">
          <div class="row">
            <div class="col-auto">
              <div class="img-frame">
                <i
                  v-if="files.profile_update"
                  class="bi bi-arrow-down-circle-fill profile-picker-download"
                  @click.stop="download_files(files.img_uid, null)"
                ></i>
                <label
                  :class="
                    isUpdateMode && files.profileURL && files.profile_update
                      ? 'profile-picker-update'
                      : 'profile-picker'
                  "
                  @click.stop="onCameraClick"
                >
                  <i class="bi bi-camera-fill"></i>
                </label>
                <span class="cover"></span>
                <div v-if="files.profileURL" class="p-0">
                  <img
                    :src="files.profileURL"
                    alt="Image"
                    class="profile-img"
                  />
                </div>
              </div>
              <input
                type="file"
                ref="profilepicker"
                class="d-none"
                :accept="const_var.allowedFileTypes"
                @change="profileChange"
              />
              <div
                class="modal fade"
                id="photoChoiceModal"
                tabindex="-1"
                ref="photoChoiceModal"
              >
                <div class="modal-dialog modal-dialog-centered modal-sm">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title">Profile Image</h5>
                      <button
                        class="btn-close"
                        @click="closePhotoChoice"
                      ></button>
                    </div>
                    <div class="modal-body text-center">
                      <div class="d-grid gap-3">
                        <div class="choice-card" @click="selectFromDevice">
                          <i class="bi bi-image"></i>
                          <div>Select Image</div>
                        </div>

                        <div
                          class="choice-card"
                          @click="isSecureContext ? captureFromCamera() : null"
                          :class="{ disabled: !isSecureContext }"
                          :title="
                            isSecureContext
                              ? 'Capture from camera'
                              : 'Camera Access not allowed.'
                          "
                        >
                          <i class="bi bi-camera"></i>
                          <div>Capture Photo</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <CameraCapture ref="camera" @captured="saveCapturedImage" />
            </div>
          </div>
        </div>
        <!-- StartOF写真側 -->
      </div>
      <!-- EndOFフォーム -->
      <!-- EndOF Applicant Profile行 -->
      <!-- StartOF License And Qualifications -->
      <div ref="license_list" class="mt-3 row">
        <div class="col">
          <h4 class="fw-bold">License And Qualifications</h4>
        </div>
      </div>
      <!-- StartOF License And Qualificationsフォーム -->
      <div v-if="license_and_qualifications.length > 0">
        <div class="row mb-2 multi-border">
          <div class="mutli-overflow">
            <div
              v-for="(row, index) in license_and_qualifications"
              :key="index"
              class="mutli-container"
            >
              <div class="col multi-box-date">
                <div class="row" v-if="index == 0">
                  <label class="form-label col"
                    >Acquired Date<span class="text-danger">*</span></label
                  >
                </div>
                <div class="row mt-1">
                  <div class="col date-container">
                    <input
                      v-maska:[date_mask.ym_option]
                      v-model="row.acquired_date"
                      :class="{
                        'is-invalid':
                          error.license_and_qualifications[index].acquired_date,
                      }"
                      class="form-control form-control-sm selectBorder ym-date-box"
                      :placeholder="date_mask.ym_placeholder"
                    />
                  </div>
                </div>
              </div>
              <div class="col multi-box-content">
                <div class="row" v-if="index == 0">
                  <label class="form-label col"
                    >Category<span class="text-danger">*</span></label
                  >
                </div>
                <div class="row mt-1">
                  <div class="col">
                    <select
                      v-model="row.category"
                      :class="{
                        'is-invalid':
                          error.license_and_qualifications[index].category,
                      }"
                      class="form-select form-select-sm"
                      @change="handleLicenseCategoryChange(row)"
                    >
                      <option value="">Select</option>
                      <option
                        v-for="c in drop_down.qualification_category"
                        :key="c.value"
                        :value="c.value"
                      >
                        {{ c.en }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="col multi-box-content">
                <div class="row" v-if="index == 0">
                  <label class="form-label col"
                    >Qualification<span class="text-danger">*</span></label
                  >
                </div>
                <div class="row mt-1">
                  <div class="col multi-last">
                    <input
                      v-if="row.category === 'IQTest'"
                      type="text"
                      @input="
                        row.qualification = row.qualification.replace(
                          /\D/g,
                          '',
                        );
                        handleLicenseQualificationChange(row);
                      "
                      :maxlength="max_length.height_weight"
                      v-model="row.qualification"
                      class="form-control form-control-sm"
                      :class="{
                        'is-invalid':
                          error.license_and_qualifications[index].qualification,
                      }"
                      placeholder="Enter IQ Test Scores "
                    />
                    <select
                      v-else
                      v-model="row.qualification"
                      :class="{
                        'is-invalid':
                          error.license_and_qualifications[index].qualification,
                      }"
                      class="form-select form-select-sm"
                      :disabled="!row.category"
                      @change="handleLicenseQualificationChange(row)"
                    >
                      <option value="">Select</option>
                      <option
                        v-for="q in qualificationOptions(row.category)"
                        :key="q.en"
                        :value="q.en"
                      >
                        {{ q.en }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="col multi-box-content">
                <div class="row" v-if="index == 0">
                  <label class="form-label col">Status<span class="text-danger">*</span></label>
                </div>
                <div class="row mt-1">
                  <div class="col multi-last">
                    <select
                      v-model="row.status"
                      class="form-select form-select-sm"
                      :disabled="
                        !isLicenseStatusEnabled(row.category, row.qualification)
                      "
                      :class="{
                        'is-invalid':
                          error.license_and_qualifications[index].status,
                      }"
                    >
                      <option value="">Select</option>
                      <option
                        v-for="status in drop_down.qualification_status"
                        :key="status.value"
                        :value="status.value"
                      >
                        {{ status.en }}
                      </option>
                    </select>
                    <button
                      type="button"
                      v-on:click="deleteRow(index, 'license')"
                      class="btn fs-5 p-0"
                    >
                      <i class="bi bi-dash-circle-fill"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- EndOF License And Qualificationsフォーム -->
      <!-- Add new btn -->
      <div class="col-3">
        <button
          type="button"
          v-on:click="addRow('license')"
          class="btn addRow btn-sm"
        >
          <i class="bi bi-plus-circle-fill fs-6"></i> Add New
        </button>
      </div>
      <!-- Add new btn end -->
      <!-- StartOF Education行 -->
      <div ref="edu_list" class="mt-3 row">
        <div class="col">
          <h4 class="fw-bold">Education</h4>
        </div>
      </div>
      <!-- StartOF Educationフォーム -->
      <div v-if="education.length > 0">
        <div class="row mb-2 multi-border">
          <div class="mutli-overflow">
            <div
              v-for="(row, index) in education"
              :key="index"
              class="mutli-container"
            >
              <div class="col multi-box-date">
                <div class="row" v-if="index == 0">
                  <label class="form-label col"
                    >Period<span class="text-danger">*</span></label
                  >
                </div>
                <div class="row mt-1">
                  <div class="col date-container">
                    <input
                      v-maska:[date_mask.ym_option]
                      v-model="row.start_date"
                      :class="{
                        'is-invalid': error.education[index].start_date,
                      }"
                      class="form-control form-control-sm selectBorder ym-date-box"
                      :placeholder="date_mask.ym_placeholder"
                    />
                    <span class="date-seperator">～</span>
                    <input
                      v-maska:[date_mask.ym_option]
                      v-model="row.end_date"
                      :class="{ 'is-invalid': error.education[index].end_date }"
                      class="form-control form-control-sm selectBorder ym-date-box"
                      :placeholder="date_mask.ym_placeholder"
                    />
                  </div>
                </div>
              </div>
              <div class="col multi-box-content">
                <div class="row" v-if="index == 0">
                  <label class="form-label col"
                    >School<span class="text-danger">*</span></label
                  >
                </div>
                <div class="row mt-1">
                  <div class="col">
                    <input
                      type="text"
                      v-model="row.school"
                      :maxlength="max_length.edu_school"
                      :class="{ 'is-invalid': error.education[index].school }"
                      class="form-control form-control-sm"
                      placeholder="Enter School Name And Township Name"
                    />
                  </div>
                </div>
              </div>
              <div class="col multi-box-content">
                <div class="row" v-if="index == 0">
                  <label class="form-label col"
                    >Grade<span class="text-danger">*</span></label
                  >
                </div>
                <div class="row mt-1">
                  <div class="col multi-last">
                    <select
                      v-model="row.edu_grade"
                      :class="{
                        'is-invalid': error.education[index].edu_grade,
                      }"
                      class="form-select form-select-sm selectBorder"
                    >
                      <option selected value="">Select</option>
                      <option
                        v-for="(value, key) in drop_down.edu_grade"
                        :key="key"
                        :value="key"
                      >
                        {{ value }}
                      </option>
                    </select>
                    <button
                      type="button"
                      v-on:click="deleteRow(index, 'education')"
                      class="btn fs-5 p-0"
                    >
                      <i class="bi bi-dash-circle-fill"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- EndOF Educationフォーム -->
      <!-- Add new btn -->
      <div class="col-3">
        <button
          type="button"
          v-on:click="addRow('education')"
          class="btn addRow btn-sm"
        >
          <i class="bi bi-plus-circle-fill fs-6"></i> Add New
        </button>
      </div>
      <!-- Add new btn end -->
      <!-- EndOF Education行-->
      <!-- StartOF Work History行 -->
      <div ref="work_his" class="mt-3 row">
        <div class="col">
          <h4 class="fw-bold">Work History</h4>
        </div>
      </div>
      <!-- StartOF Work Historyフォーム -->
      <div v-if="work_histories.length > 0">
        <div class="row mb-2 multi-border">
          <div class="mutli-overflow">
            <div
              v-for="(row, index) in work_histories"
              :key="index"
              class="mutli-container"
            >
              <div class="col multi-box-date">
                <div class="row" v-if="index == 0">
                  <label class="form-label col"
                    >Period<span class="text-danger">*</span></label
                  >
                </div>
                <div class="row mt-1">
                  <div class="col date-container">
                    <input
                      v-maska:[date_mask.ym_option]
                      v-model="row.start_date"
                      :class="{
                        'is-invalid': error.work_histories[index].start_date,
                      }"
                      class="form-control form-control-sm selectBorder ym-date-box"
                      :placeholder="date_mask.ym_placeholder"
                    />
                    <span class="date-seperator">～</span>
                    <input
                      v-maska:[date_mask.ym_option]
                      v-model="row.end_date"
                      :class="{
                        'is-invalid': error.work_histories[index].end_date,
                      }"
                      class="form-control form-control-sm selectBorder ym-date-box"
                      :placeholder="date_mask.ym_placeholder"
                    />
                  </div>
                </div>
              </div>
              <div class="col multi-box-content">
                <div class="row" v-if="index == 0">
                  <label class="form-label col"
                    >Organization<span class="text-danger">*</span></label
                  >
                </div>
                <div class="row mt-1">
                  <div class="col">
                    <input
                      type="text"
                      v-model="row.organization"
                      :maxlength="max_length.work_organization"
                      :class="{
                        'is-invalid': error.work_histories[index].organization,
                      }"
                      class="form-control form-control-sm"
                    />
                  </div>
                </div>
              </div>
              <div class="col multi-box-content">
                <div class="row" v-if="index == 0">
                  <label class="form-label col">Job Category</label>
                </div>
                <div class="row mt-1">
                  <div class="col">
                    <select
                      v-model="row.job_category_uid"
                      class="form-select form-select-sm selectBorder"
                    >
                      <option selected value="">Select</option>
                      <option
                        v-for="categoryItem in drop_down.jobCategory"
                        :key="categoryItem.uid"
                        :value="categoryItem.uid"
                      >
                        {{ categoryItem.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="col multi-box-content">
                <div class="row" v-if="index == 0">
                  <label class="form-label col"
                    >Position<span class="text-danger">*</span></label
                  >
                </div>
                <div class="row mt-1">
                  <div class="col multi-last">
                    <input
                      type="text"
                      v-model="row.position"
                      :maxlength="max_length.work_position"
                      :class="{
                        'is-invalid': error.work_histories[index].position,
                      }"
                      class="form-control form-control-sm"
                    />
                  </div>
                </div>
              </div>
              <div class="col multi-box-content">
                <div class="row" v-if="index == 0">
                  <label class="form-label col">Monthly Salary</label>
                </div>
                <div class="row mt-1">
                  <div class="col multi-last">
                    <input
                      type="text"
                      v-model="row.monthly_salary"
                      @input="
                        row.monthly_salary = row.monthly_salary.replace(
                          /\D/g,
                          '',
                        )
                      "
                      :maxlength="max_length.salary"
                      class="form-control form-control-sm"
                    />
                    <button
                      type="button"
                      v-on:click="deleteRow(index, 'work_histories')"
                      class="btn fs-5 p-0"
                    >
                      <i class="bi bi-dash-circle-fill"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- EndOF Work Historyフォーム -->
      <!-- Add new btn -->
      <div class="col-3">
        <button
          type="button"
          v-on:click="addRow('work_histories')"
          class="btn addRow btn-sm"
        >
          <i class="bi bi-plus-circle-fill fs-6"></i> Add New
        </button>
      </div>
      <!-- Add new btn end -->
      <!-- EndOF Work History行-->
      <!-- StartOF Family Members行 -->
      <div ref="family_member" class="mt-3 row">
        <div class="col">
          <h4 class="fw-bold">Family Members</h4>
        </div>
      </div>
      <!-- StartOF Work Historyフォーム -->
      <div v-if="family_members.length > 0">
        <div class="row mb-2 multi-border">
          <div class="mutli-overflow">
            <div
              v-for="(row, index) in family_members"
              :key="index"
              class="mutli-container"
            >
              <div class="col multi-box-content">
                <div class="row" v-if="index == 0">
                  <label class="form-label col"
                    >Name<span class="text-danger">*</span></label
                  >
                </div>
                <div class="row mt-1">
                  <div class="col">
                    <input
                      type="text"
                      v-model="row.name"
                      :maxlength="max_length.family_name"
                      :class="{
                        'is-invalid': error.family_members[index].name,
                      }"
                      class="form-control form-control-sm"
                    />
                  </div>
                </div>
              </div>
              <div class="col multi-box-content">
                <div class="row" v-if="index == 0">
                  <label class="form-label col"
                    >Relations<span class="text-danger">*</span></label
                  >
                </div>
                <div class="row mt-1">
                  <div class="col">
                    <input
                      type="text"
                      v-model="row.relations"
                      :maxlength="max_length.family_relation"
                      :class="{
                        'is-invalid': error.family_members[index].relations,
                      }"
                      class="form-control form-control-sm"
                    />
                  </div>
                </div>
              </div>
              <div class="col live-with-col">
                <div class="row" v-if="index == 0">
                  <label class="form-label col">Live With</label>
                </div>
                <div class="row mt-1">
                  <div class="col">
                    <div class="form-check live-with-chk">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        v-model="row.live_with"
                        :Selected="row.live_with == 1"
                      />
                      <div class="text-start">
                        <label class="form-check-label" for="flexCheckChecked"
                          >Yes</label
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col age-col">
                <div class="row" v-if="index == 0">
                  <label class="form-label col">Age</label>
                </div>
                <div class="row mt-1">
                  <div class="col">
                    <input
                      type="number"
                      v-model="row.age"
                      class="form-control form-control-sm familyAge"
                    />
                  </div>
                </div>
              </div>
              <div class="col multi-box-content">
                <div class="row" v-if="index == 0">
                  <label class="form-label">Place of work</label>
                </div>
                <div class="row mt-1">
                  <div class="col">
                    <input
                      type="text"
                      v-model="row.work_place"
                      :maxlength="max_length.family_work_place"
                      class="form-control form-control-sm"
                    />
                  </div>
                </div>
              </div>
              <div class="col multi-box-content">
                <div class="row" v-if="index == 0">
                  <label class="form-label col">Occupations</label>
                </div>
                <div class="row mt-1">
                  <div class="col multi-last">
                    <input
                      type="text"
                      v-model="row.occupations"
                      :maxlength="max_length.family_occupation"
                      class="form-control form-control-sm"
                    />
                    <button
                      type="button"
                      v-on:click="deleteRow(index, 'family')"
                      class="btn fs-5 p-0"
                    >
                      <i class="bi bi-dash-circle-fill"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- EndOF Family Membersフォーム -->
      <!-- Add new btn -->
      <div class="col-3">
        <button
          type="button"
          v-on:click="addRow('family')"
          class="btn addRow btn-sm"
        >
          <i class="bi bi-plus-circle-fill fs-6"></i> Add New
        </button>
      </div>
      <!-- Add new btn end -->
      <!-- EndOF Family Members行-->
      <!-- StartOF Confirmation行 -->
      <div class="mt-3 row">
        <div class="col">
          <h4 class="fw-bold">Confirmation</h4>
        </div>
      </div>
      <!-- StartOFフォーム -->
      <div class="mb-1 row">
        <label class="col-md-2 col-form-label">Medical History</label>
        <div class="col-md-8 col-form-label">
          <div
            v-for="(value, key) in radio.yes_no"
            :key="key"
            class="form-check form-check-inline"
          >
            <input
              class="form-check-input"
              type="radio"
              v-model="applicants.medical_check"
              :value="key"
            />
            <label class="form-check-label">{{ value }}</label>
          </div>
        </div>
      </div>
      <div class="mb-1 row">
        <label class="col-md-2 col-form-label">Smoking</label>
        <div class="col-md-8 col-form-label">
          <div
            v-for="(value, key) in radio.yes_no"
            :key="key"
            class="form-check form-check-inline"
          >
            <input
              class="form-check-input"
              type="radio"
              v-model="applicants.smoking"
              :value="key"
            />
            <label class="form-check-label">{{ value }}</label>
          </div>
        </div>
      </div>
      <div class="mb-1 row">
        <label class="col-md-2 col-form-label">Drinking</label>
        <div class="col-md-8 col-form-label">
          <div
            v-for="(value, key) in radio.yes_no"
            :key="key"
            class="form-check form-check-inline"
          >
            <input
              class="form-check-input"
              type="radio"
              v-model="applicants.drinking"
              :value="key"
            />
            <label class="form-check-label">{{ value }}</label>
          </div>
        </div>
      </div>
      <div class="mb-1 row">
        <label class="col-md-2 col-form-label">Handedness</label>
        <div class="col-md-8 col-form-label">
          <div
            v-for="(value, key) in radio.handedness"
            :key="key"
            class="form-check form-check-inline"
          >
            <input
              class="form-check-input"
              type="radio"
              v-model="applicants.handedness"
              :value="key"
            />
            <label class="form-check-label">{{ value }}</label>
          </div>
        </div>
      </div>
      <div class="row">
        <label class="col-md-2 col-form-label">Marital Status</label>
        <div class="col-md-8 col-form-label">
          <div
            v-for="(value, key) in radio.marital_status"
            :key="key"
            class="form-check form-check-inline"
          >
            <input
              class="form-check-input"
              type="radio"
              v-model="applicants.marital_status"
              :value="key"
            />
            <label class="form-check-label">{{ value }}</label>
          </div>
        </div>
      </div>
      <!-- EndOFフォーム -->
      <!-- EndOF Confirmation行 -->
      <!-- StartOF Job Transaction行 -->
      <div v-if="applicants.uid">
        <div class="mt-3 row">
          <div class="col">
            <h4 class="fw-bold">Job Transaction</h4>
          </div>
        </div>
        <!-- StartOF Job Transaction一覧表 -->
        <div class="row" v-if="job_transactions_list.length > 0">
          <div class="col">
            <div class="job-transaction-list">
              <table class="table table-sm table-bordered">
                <thead>
                  <tr class="tbl-th">
                    <td class="no-col">No</td>
                    <td class="job-Type-col">Job Type</td>
                    <td class="sup-org-col">Supervision Organization</td>
                    <td class="imp-org-col">Implementing Organization</td>
                    <td class="interview-date-col">Interview Date</td>
                    <td class="btn-col"></td>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(row, index) in job_transactions_list"
                    :key="index"
                  >
                    <td class="text-center">{{ index + 1 }}</td>
                    <td>{{ row.occupation_type }}</td>
                    <td>{{ row.supervision_organization }}</td>
                    <td>{{ row.implementing_organization }}</td>
                    <td class="text-center">{{ row.interview_date }}</td>
                    <td class="text-center">
                      <i
                        class="bi bi-trash3-fill fs-6"
                        v-on:click="delete_job_tran_applicant(row.uid, index)"
                      ></i>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div v-else>Nothing to show..</div>
      </div>
      <!-- EndOF Job Transaction一覧表 -->
      <!-- EndOF Job Transaction行 -->
      <!-- StartOF Other Info行 -->
      <div ref="other_info" class="mt-3 row">
        <div class="col">
          <h4 class="fw-bold">Other Info</h4>
        </div>
      </div>
      <!-- StartOF Other Infoフォーム -->
      <div class="row">
        <!-- StartOF左側 -->
        <div class="col-md-6">
          <div class="mb-1 row">
            <label class="col-md-5 col-form-label">Passport No.</label>
            <div class="col-md-7">
              <input
                type="text"
                v-model="applicants.passport_no"
                :maxlength="max_length.passport_no"
                class="form-control form-control-sm w-50"
              />
            </div>
          </div>
          <div class="mb-1 row">
            <label class="col-md-5 col-form-label">Valid until</label>
            <div class="col-md-7">
              <input
                v-maska:[date_mask.date_option]
                v-model="applicants.passport_exp_date"
                :class="{ 'is-invalid': error.passport_exp_date }"
                class="form-control form-control-sm selectBorder w-50"
                :placeholder="date_mask.placeholder"
              />
            </div>
          </div>
          <div class="mb-1 row">
            <label class="col-md-5 col-form-label">Passport type</label>
            <div class="col-md-7">
              <select
                v-model="applicants.passport_type"
                class="form-select form-select-sm w-50 selectBorder"
              >
                <option selected value="">Select</option>
                <option
                  v-for="value in drop_down.passport_type"
                  :key="value"
                  :value="value"
                >
                  {{ value }}
                </option>
              </select>
            </div>
          </div>
          <div class="mb-1 row">
            <label class="col-md-5 col-form-label"
              >Annual Saving Goal (LKR)</label
            >
            <div class="col-md-7">
              <input
                type="text"
                v-model="applicants.annual_saving_goal"
                @input="
                  applicants.annual_saving_goal =
                    applicants.annual_saving_goal.replace(/\D/g, '')
                "
                :maxlength="max_length.annual_saving_goal"
                class="form-control form-control-sm w-50"
              />
            </div>
          </div>
          <div class="mb-1 row">
            <label class="col-md-5 col-form-label"
              >Desired Employment Period</label
            >
            <div class="col-md-7 eye-container">
              <input
                type="text"
                v-model="applicants.desired_employment_period"
                @input="
                  applicants.desired_employment_period =
                    applicants.desired_employment_period.replace(/\D/g, '')
                "
                maxlength="2"
                class="form-control form-control-sm number-col"
              />
              <label class="col-form-label">years</label>
            </div>
          </div>
        </div>
        <!-- EndOF左側 -->
        <!-- StartOF右側 -->
        <div class="col-md-6">
          <div class="mb-1 row">
            <label class="col-md-4 col-form-label">Interview Status</label>
            <div class="col-md-8">
              <select
                v-model="applicants.interview_status"
                class="form-select form-select-sm w-50 selectBorder"
              >
                <option selected value="">Select</option>
                <option
                  v-for="(value, key) in drop_down.interview_status"
                  :key="key"
                  :value="key"
                >
                  {{ value }}
                </option>
              </select>
            </div>
          </div>
          <div class="mb-1 row">
            <label class="col-md-4 col-form-label">Apply Date</label>
            <div class="col-md-8">
              <input
                v-maska:[date_mask.date_option]
                v-model="applicants.apply_date"
                :class="{ 'is-invalid': error.apply_date }"
                class="form-control form-control-sm selectBorder w-50"
                :placeholder="date_mask.placeholder"
              />
            </div>
          </div>
          <div class="mb-1 row">
            <label class="col-md-4 col-form-label"
              >Foreign Travel History</label
            >
            <div class="col-md-8">
              <multiselect
                v-model="selectedCountries"
                :options="drop_down.travelCountry"
                :multiple="true"
                :close-on-select="false"
                placeholder="Select countries"
                :searchable="true"
                label="en"
                track-by="en"
              >
              </multiselect>
            </div>
          </div>
          <div class="mb-1 row">
            <label class="col-md-4 col-form-label"
              >Other Possible Language</label
            >
            <div class="col-md-8">
              <multiselect
                v-model="selectedLanguages"
                :options="drop_down.language"
                :multiple="true"
                :close-on-select="false"
                placeholder="Select languages"
                :searchable="true"
                label="en"
                track-by="en"
              >
              </multiselect>
            </div>
          </div>
        </div>
        <!-- EndOF右側 -->
      </div>
      <!-- EndOF Other Infoフォーム -->
      <!-- EndOF Other Info行 -->
      <!-- StartOF Referal Status行 -->
      <div class="mt-3 row">
        <div class="col">
          <h4 class="fw-bold">Referal Status</h4>
        </div>
      </div>
      <!-- StartOF Referal Statusフォーム -->
      <div class="mb-1 row">
        <label class="col-md-2 col-form-label">Has Referal</label>
        <div class="col-md-4 col-form-label">
          <div
            v-for="(value, key) in radio.yes_no"
            :key="key"
            class="form-check form-check-inline"
          >
            <input
              class="form-check-input"
              type="radio"
              v-model="applicants.has_refer"
              :value="key"
            />
            <label class="form-check-label">{{ value }}</label>
          </div>
        </div>
        <label class="col-md-2 col-form-label">Recruited from</label>
        <div class="col-md-4">
          <select
            v-model="applicants.recruited_from"
            :disabled="applicants.has_refer != 1"
            class="form-select form-select-sm"
          >
            <option value="">Select</option>
            <option
              v-for="value in drop_down.recruited_from"
              :key="value"
              :value="value"
            >
              {{ value }}
            </option>
          </select>
        </div>
      </div>
      <!-- EndOF Referal Statusフォーム -->
      <!-- EndOF Referal Status行 -->
      <!-- StartOF All Files and Remark 行 -->
      <div class="mt-3 row">
        <div class="col-md-6">
          <h4 class="fw-bold">All Files</h4>
        </div>
        <div class="col-md-6">
          <h4 class="fw-bold">Remark</h4>
        </div>
      </div>
      <!-- StartOF All Files and Remark フォーム -->
      <div class="row">
        <div class="col-md-6">
          <div class="file-frame">
            <div class="file-table">
              <table
                v-if="files.filesName"
                class="table table-striped table-sm table-responsive"
              >
                <tbody>
                  <tr
                    v-for="(row, index) in files.filesName"
                    :key="row.index"
                    class="row mx-1"
                  >
                    <td class="col-10 text-load">
                      <i class="bi bi-paperclip fs-6"></i>
                      <span data-toggle="tooltip" v-bind:title="row.file_name">
                        {{ row.file_name }}</span
                      >
                    </td>
                    <td class="text-center col-1">
                      <i
                        class="bi bi-arrow-down-circle-fill fs-5"
                        v-on:click="download_files(row.uid, index)"
                        v-if="row.uid != null"
                      ></i>
                    </td>
                    <td class="text-center col-1">
                      <i
                        class="bi bi-x-circle-fill fs-5"
                        v-on:click="delete_files(row.uid, index)"
                      ></i>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <textarea
            v-model="applicants.remark"
            cols="40"
            rows="8"
            :maxlength="max_length.remark"
            placeholder="Please type the remark here..."
            class="form-control form-control-sm selectBorder"
          ></textarea>
        </div>
      </div>
      <!-- EndOF All Files and Remark フォーム -->

      <!-- StartOF Attachment Button 行 -->
      <div class="mt-1 row">
        <div class="col-md-4">
          <label for="filepicker" class="btn btn-success filepicker"
            >Attachment</label
          >
          <input
            type="file"
            v-on:change="fileChange"
            id="filepicker"
            class="d-none"
            multiple
          />
        </div>
      </div>
      <!-- EndOF Attachment Button 行 -->
      <!-- StartOFボタン -->
      <div class="row text-center my-3">
        <div class="col">
          <button
            v-if="applicants.uid && permission && permission.data.preview === 1"
            v-on:click="PreviewData"
            class="btn btn-preview"
          >
            Preview
          </button>
          <button
            v-if="
              applicants.uid && permission && permission.data.app_update === 1
            "
            v-on:click="addUpdateData"
            class="btn btn-primary"
          >
            Update
          </button>
          <button
            v-if="
              !applicants.uid && permission && permission.data.app_create === 1
            "
            v-on:click="addUpdateData"
            class="btn btn-primary"
          >
            Save
          </button>
          <button
            v-if="
              permission &&
              (permission.data.app_update === 1 ||
                permission.data.app_create === 1)
            "
            v-on:click="CancelData"
            class="btn btn-secondary"
          >
            Cancel
          </button>
          <button
            v-if="
              applicants.uid && permission && permission.data.app_delete === 1
            "
            v-on:click="deleteData"
            class="btn btn-danger"
          >
            <span v-if="applicants.del_flg == 0">Delete</span>
            <span v-else>Restore</span>
          </button>
        </div>
      </div>
      <loading-modal
        :loading="loading_model.process_loading"
        :loading_text="loading_model.loading_text"
      ></loading-modal>
      <!-- EndOFボタン -->
    </div>
    <i
      v-on:click="AddData"
      v-if="
        applicants.uid &&
        permission &&
        (permission.data.app_update === 1 || permission.data.app_create === 1)
      "
      class="bi bi-plus-circle-fill side-add-btn"
      title="Add New"
    ></i>
  </MenuLayout>
</template>
<style lang="css" scoped src="@/assets/css/applicantReg.css"></style>
<style scoped>
.eye-container select {
  font-size: 0.75rem;
  padding-right: 1.5rem;
  background-size: 0.5rem 0.5rem;
}
</style>
<script>
import MenuLayout from "@/components/MenuLayout.vue";
import Configuration from "@/Service/configuration.js";
import DataService from "@/Service/data-service.js";
import Resources from "@/Service/resources.js";
import ConstantVar from "@/Service/constant-var.js";
import Enum from "@/Service/enum.js";
import Swal from "sweetalert2";
import LoadingModal from "@/components/LoadingModal.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import $ from "jquery";
import { vMaska } from "maska";
import { mapState } from "vuex";
import { swal_option } from "@/Util/swal-option.js";
import { msg_code } from "@/Util/msg_code.js";
import { calculateAge } from "@/Util/calculateAge.js";
import { whiteSpaceCase } from "@/Util/whiteSpaceCase.js";
import { deleteUnnecessary } from "@/Util/deleteUnnecessary.js";
import { checkDate } from "@/Util/checkDate.js";
import { checkDateYM } from "@/Util/checkDateYM.js";
import { dropdownSelect } from "@/Util/dropdownSelect.js";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
import CameraCapture from "@/components/CameraCapture.vue";
import * as bootstrap from "bootstrap";

var resource = new Resources();
var dataService = new DataService();
var config = new Configuration();
var enums = new Enum();
var con_var = new ConstantVar();
$(document).on("keypress", ".familyAge", function () {
  if (this.value.length == 2) {
    return false;
  }
});
export default {
  components: {
    Multiselect,
    MenuLayout,
    LoadingSpinner,
    "loading-modal": LoadingModal,
    CameraCapture,
  },
  directives: { maska: vMaska },
  data() {
    return {
      showChoice: false,
      useCamera: false,
      photoChoiceModal: null,
      const_var: {},
      date_mask: {},
      max_length: {},
      loading: null,
      loading_model: {},
      age: null, // 年齢見せる変数
      job_transactions: {}, // 今勤めている会社変数
      job_transactions_list: [], // 今の職歴変数
      delete_job_uid: [],
      change_file_uid: {},
      license_and_qualifications: [],
      education: [], // 応募者学歴の要求データ変数
      work_histories: [], // 応募者昔職歴の要求データ変数
      family_members: [], // 応募者家族の要求データ変数
      selectedCountries: [],
      selectedLanguages: [],
      cityOptions: [],
      applicants: {
        // 応募者の要求データ変数
        gender: "M",
        has_refer: 0,
        recruited_from: "",
        medical_check: 0,
        smoking: 0,
        drinking: 0,
        handedness: "R",
        blood_type: "",
        religion: "",
        race: "",
        birth_state: "",
        birth_city: "",
        passport_type: "",
        marital_status: "S",
        interview_status: "",
        remark: "",
      },
      files: {
        profile_update: false,
        img_uid: null,
        img_name: null,
        profile: null,
        profileURL: null,
        selectedFiles: [],
        filesName: [],
      },
      drop_down: {
        qualification_category: [],
        qualification_status: [],
        jobCategory: [],
        blood_type: [],
        religion: [],
        race: [],
        brithState: [],
        travelCountry: [],
        language: [],
        edu_grade: [],
        passport_type: [],
        interview_status: [],
        recruited_from: [],
      },
      radio: {
        gender: [],
        marital_status: [],
        yes_no: [],
        handedness: [],
      },
      error: {
        name_eng: false,
        dob: false,
        age: false,
        passport_exp_date: false,
        apply_date: false,
        birth_city: false,
        license_and_qualifications: [],
        education: [],
        work_histories: [],
        family_members: [],
      },
    };
  },
  computed: {
    ...mapState(["userID", "permission"]),
    isUpdateMode() {
      return !!this.$route.params.uid;
    },
    isSecureContext() {
      return window.isSecureContext;
    },
  },
  watch: {
    "applicants.has_refer"(value) {
      if (value != 1) {
        this.applicants.recruited_from = "";
      }
    },
  },
  async mounted() {
    this.const_var = con_var.REG_CONST;
    this.date_mask = con_var.DATE_MASK;
    this.max_length = con_var.APPLICANT_MAX_LENGTH;
    this.loading = con_var.LOADING_INTI;
    this.loading_model = con_var.LOADING_MODEL;
    this.drop_down.blood_type = enums.BLOOD_TYPE;
    this.drop_down.religion = enums.RELIGION;
    this.drop_down.race = con_var.RACE;
    this.drop_down.qualification_category = con_var.QUALIFICATION_CATEGORY;
    this.drop_down.qualification_status = con_var.QUALIFICATION_STATUS;
    this.drop_down.brithState = con_var.STATE;
    this.drop_down.travelCountry = con_var.TRAVEL_COUNTRY;
    this.drop_down.language = con_var.LANGUAGE;
    this.drop_down.recruited_from = con_var.REFERAL_SCHOOL;
    this.drop_down.passport_type = enums.PASSPORT_TYPE;
    this.radio.marital_status = enums.MARITAL_STATUS;
    this.drop_down.interview_status = enums.INTERVIEW_STATUS;
    this.drop_down.edu_grade = enums.EDU_GRADE;
    this.drop_down.eyesight_values = enums.EYESIGHT_VALUES;
    this.radio.yes_no = enums.YES_NO;
    this.radio.gender = enums.GENDER;
    this.radio.handedness = enums.HANDEDNESS;
    var serverResponse = await dataService.retrieveWithGet(
      config.SERVICE_NAME_JOB_CATEGORY,
    );
    if (serverResponse.success == true && serverResponse.error == false) {
      this.drop_down.jobCategory = serverResponse.data;
    }
    this.loading = false;
    this.$nextTick(() => {
      if (this.$refs.photoChoiceModal) {
        this.photoChoiceModal = new bootstrap.Modal(
          this.$refs.photoChoiceModal,
          {
            backdrop: "static",
            keyboard: false,
          },
        );
      }
    });
  },
  async created() {
    if (this.$route.params.uid) {
      var serverResponse = await dataService.retrieveWithGet(
        config.SERVICE_NAME_APPLICANT + "/" + this.$route.params.uid,
      );
      if (serverResponse.success == true && serverResponse.error == false) {
        if (serverResponse.data["job_transactions"]) {
          this.job_transactions = serverResponse.data["job_transactions"];
        } else {
          this.job_transactions = {
            interview_date: "",
            supervision_organization: "",
            implementing_organization: "",
            occupation_type: "",
          };
        }
        this.applicants = serverResponse.data["applicants"];
        this.selectedCountries = this.drop_down.travelCountry.filter((c) =>
          this.applicants.foreign_travel_history.split(",").includes(c.en),
        );
        this.selectedLanguages = this.drop_down.language.filter((l) =>
          this.applicants.other_possible_languages.split(",").includes(l.en),
        );
        this.applicants = dropdownSelect(this.applicants, "applicant");
        this.license_and_qualifications =
          serverResponse.data["license_and_qualifications"];
        this.license_and_qualifications = this.license_and_qualifications.map(
          (row) => this.normalizeLicenseRow(row),
        );
        for (let i = 0; i < this.license_and_qualifications.length; i++) {
          this.error.license_and_qualifications.push({
            acquired_date: false,
            category: false,
            qualification: false,
            status: false,
          });
        }
        this.education = serverResponse.data["education"];
        for (let i = 0; i < this.education.length; i++) {
          this.error.education.push({
            start_date: false,
            end_date: false,
            school: false,
            edu_grade: false,
          });
        }
        this.work_histories = serverResponse.data["work_histories"];
        for (let i = 0; i < this.work_histories.length; i++) {
          this.work_histories[i] = dropdownSelect(
            this.work_histories[i],
            "work",
          );
          this.error.work_histories.push({
            start_date: false,
            end_date: false,
            organization: false,
            position: false,
          });
        }
        this.family_members = serverResponse.data["family_members"];
        for (let i = 0; i < this.family_members.length; i++) {
          if (this.family_members[i].live_with == 1)
            this.family_members[i].live_with = true;
          else this.family_members[i].live_with = false;
          this.error.family_members.push({ name: false, relations: false });
        }
        this.calculateAge();
        if (this.applicants.birth_state) {
          this.stateChange(true);
        }
        this.job_transactions_list =
          serverResponse.data["job_transactions_list"];
        if (serverResponse.data["files"]) {
          //ファイルパス
          for (const key in serverResponse.data["files"]) {
            if (serverResponse.data["files"][key].p_flg == 1) {
              this.files.profile_update = true;
              this.files.img_uid = serverResponse.data["files"][key].uid;
              this.files.img_name =
                serverResponse.data["files"][key].path.split("/");
              // Add timestamp to prevent browser caching
              const timestamp = new Date().getTime();
              this.files.profileURL =
                resource.BACKEND_SIDE_BASE_URL +
                config.SERVICE_NAME_FILES +
                serverResponse.data["files"][key].path +
                "?t=" +
                timestamp;
            } else {
              var path = serverResponse.data["files"][key].path.split("/");
              this.files.filesName.push({
                file_name: path[path.length - 1],
                uid: serverResponse.data["files"][key].uid,
              });
            }
          }
        }
      } else if (
        serverResponse.success == false &&
        serverResponse.error == false
      ) {
        this.reset();
        Swal.fire(swal_option("warn", serverResponse.message));
      } else {
        Swal.fire(swal_option("error", msg_code("ef001")));
      }
    }
  },
  methods: {
    openPhotoChoice() {
      if (!this.photoChoiceModal) return;
      this.photoChoiceModal.show();
    },
    closePhotoChoice() {
      if (this.photoChoiceModal) {
        this.photoChoiceModal.hide();
      }
    },
    selectFromDevice() {
      this.closePhotoChoice();
      this.$refs.profilepicker.click();
    },
    captureFromCamera() {
      this.closePhotoChoice();
      this.$refs.camera.openModal();
    },
    // open file picker
    openFilePicker() {
      this.$refs.filepicker.click();
    },
    // start camera mode
    startCamera() {
      this.showChoice = false;
      this.useCamera = true;
    },
    saveCapturedImage(photoData) {
      if (!photoData) {
        console.error("Captured image is NULL");
        return;
      }
      this.files.profileURL = photoData;
      const arr = photoData.split(",");
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      this.files.profile = new File([u8arr], "captured.jpg", { type: mime });
    },
    async checkApplicant() {
      this.loading_model = {
        process_loading: true,
        loading_text: "Processing",
      };
      let check = false;
      if (this.applicants.name_eng && this.applicants.dob) {
        if (this.applicants.name_eng.trim() && checkDate(this.applicants.dob)) {
          check = true;
        }
      }
      if (check) {
        var serverResponse = await dataService.callWithPost(
          config.SERVICE_NAME_APPLICANT_CHECK,
          this.applicants,
        );
        if (serverResponse.success == true && serverResponse.error == false) {
          Swal.fire(swal_option("success", serverResponse.message));
        } else if (
          serverResponse.success == false &&
          serverResponse.error == false
        ) {
          Swal.fire(swal_option("warn", serverResponse.message));
        } else {
          Swal.fire(swal_option("error", msg_code("ef001")));
        }
      } else {
        Swal.fire(swal_option("warn", msg_code("wf015")));
      }
      this.loading_model = con_var.LOADING_MODEL;
    },
    /* 画面 Main ボタンイベント */
    async addUpdateData() {
      this.loading_model = {
        process_loading: true,
        loading_text: "Processing",
      };
      this.applicants = whiteSpaceCase(this.applicants);
      this.nrc = whiteSpaceCase(this.nrc);
      if (this.license_and_qualifications.length > 0) {
        for (let key in this.license_and_qualifications) {
          this.license_and_qualifications[key] = deleteUnnecessary(
            this.license_and_qualifications[key],
            "license",
          );
          this.license_and_qualifications[key] = whiteSpaceCase(
            this.license_and_qualifications[key],
          );
        }
      }
      if (this.education.length > 0) {
        for (let key in this.education) {
          this.education[key] = deleteUnnecessary(
            this.education[key],
            "education",
          );
          this.education[key] = whiteSpaceCase(this.education[key]);
        }
      }
      if (this.work_histories.length > 0) {
        for (let key in this.work_histories) {
          this.work_histories[key] = deleteUnnecessary(
            this.work_histories[key],
            "work",
          );
          this.work_histories[key] = whiteSpaceCase(this.work_histories[key]);
        }
      }
      if (this.family_members.length > 0) {
        for (let key in this.family_members) {
          this.family_members[key] = deleteUnnecessary(
            this.family_members[key],
            "family",
          );
          this.family_members[key] = whiteSpaceCase(this.family_members[key]);
        }
      }
      if (this.dataCheck()) {
        var serverResponse;
        var url;
        let formData = new FormData();
        this.applicants.updated_by = this.userID;
        this.applicants.foreign_travel_history = (this.selectedCountries || [])
          .map((c) => c.en)
          .join(",");
        this.applicants.other_possible_languages = (
          this.selectedLanguages || []
        )
          .map((c) => c.en)
          .join(",");
        if (!this.applicants.uid) {
          url = config.SERVICE_NAME_APPLICANT; // 登録モード
          this.applicants.created_by = this.userID;
        } else {
          formData.append("_method", "PUT"); // 更新モード
          this.applicants = deleteUnnecessary(this.applicants, "applicant");
          url = config.SERVICE_NAME_APPLICANT + "/" + this.applicants.uid;
        }
        this.change_file_uid.profile_uid = this.files.img_uid;
        let request_data = {
          // 要求データ準備
          applicants: this.applicants,
          education: this.education,
          license_and_qualifications: this.normalizeLicensePayload(
            this.license_and_qualifications,
          ),
          work_histories: this.work_histories,
          family_members: this.family_members,
          delete_job_uid: this.delete_job_uid,
          change_file_uid: this.change_file_uid,
        };
        formData.append("data", JSON.stringify(request_data));
        if (this.files.profile != null) {
          // 応募者写真
          formData.append("profile", this.files.profile);
        }
        if (this.files.selectedFiles != null) {
          // 応募者ファイル
          Array.from(this.files.selectedFiles).forEach((file) => {
            formData.append("files[]", file);
          });
        }
        serverResponse = await dataService.callWithPost(url, formData);
        if (serverResponse.success == true && serverResponse.error == false) {
          Swal.fire(swal_option("success", serverResponse.message));
          this.reset();
        } else if (
          serverResponse.success == false &&
          serverResponse.error == false
        ) {
          Swal.fire(swal_option("warn", serverResponse.message));
        } else {
          Swal.fire(swal_option("error", msg_code("ef001")));
        }
        this.loading_model = con_var.LOADING_MODEL;
      }
    },
    PreviewData() {
      this.loading = con_var.LOADING_INTI;
      this.$router.push({
        name: "applicantPreview",
        params: { uid: this.applicants.uid },
      });
    },
    CancelData() {
      Swal.fire(swal_option("confirm", msg_code("cf008"))).then(
        async (result) => {
          if (result.isConfirmed) {
            this.reset();
          }
        },
      );
    },
    AddData() {
      Swal.fire(swal_option("confirm", msg_code("cf014"))).then(
        async (result) => {
          if (result.isConfirmed) {
            this.reset();
          }
        },
      );
    },
    async deleteData() {
      var data = {
        uid: this.applicants.uid,
        update_key: this.applicants.update_key,
      };
      var msg;
      if (this.applicants.del_flg == 0) {
        msg = msg_code("cf006");
      } else {
        msg = msg_code("cf007");
      }
      Swal.fire(swal_option("confirm", msg)).then(async (result) => {
        if (result.isConfirmed) {
          this.loading_model = {
            process_loading: true,
            loading_text: "Processing",
          };
          var serverResponse = await dataService.callWithPost(
            config.SERVICE_NAME_APPLICANT_DESTROY,
            data,
          );
          if (serverResponse.success == true && serverResponse.error == false) {
            Swal.fire(swal_option("success", serverResponse.message));
            this.reset();
          } else if (
            serverResponse.success == false &&
            serverResponse.error == false
          ) {
            Swal.fire(swal_option("warn", serverResponse.message));
          } else {
            Swal.fire(swal_option("error", msg_code("ef001")));
          }
          this.loading_model = con_var.LOADING_MODEL;
        }
      });
    },
    async onCameraClick() {
      // Update Photo
      if (this.files.profile_update) {
        await this.profilecheck();
      } else {
        this.openPhotoChoice();
      }
    },
    /* ファイル */
    async profilecheck() {
      const result = await Swal.fire(swal_option("confirm", msg_code("cf012")));
      if (result.isConfirmed) {
        this.openPhotoChoice();
      }
    },
    async profileChange(event) {
      // 応募者写真ファイル選択イベント
      this.files.profile = event.target.files[0];
      if (this.files.profile != null) {
        if (this.files.profile.size > this.const_var.img_maxSize) {
          Swal.fire(swal_option("warn", msg_code("wf009")));
        } else {
          // Revoke old blob URL to prevent memory leak
          if (
            this.files.profileURL &&
            this.files.profileURL.startsWith("blob:")
          ) {
            URL.revokeObjectURL(this.files.profileURL);
          }
          this.files.profile_update = false;
          this.files.profileURL = URL.createObjectURL(this.files.profile);
        }
      } else {
        if (this.files.img_uid != null || this.files.img_name != null) {
          Swal.fire(swal_option("warn", msg_code("wf008")));
        }
        this.files.profileURL = null;
      }
    },
    async fileChange(event) {
      // 応募者ファイル選択イベント
      const files = event.target.files;
      var foundIndex = -1;
      var large_file = false;
      for (let i = 0; i < files.length; i++) {
        var max = this.const_var.file_maxSize;
        if (this.const_var.allowedFileTypes.includes(files[i].type)) {
          max = this.const_var.img_maxSize;
        }
        if (files[i].size > max) {
          large_file = true;
        } else {
          for (let key in this.files.filesName) {
            if (this.files.filesName[key].file_name === files[i].name) {
              foundIndex = key;
              break;
            }
          }
          if (foundIndex !== -1) {
            Swal.fire(swal_option("confirm", msg_code("cf009"))).then(
              async (result) => {
                if (result.isConfirmed) {
                  if (this.files.filesName[foundIndex].uid == null) {
                    this.files.filesName.splice(foundIndex, 1);
                    this.files.selectedFiles.splice(foundIndex, 1);
                  } else {
                    this.loading_model = {
                      process_loading: true,
                      loading_text: "Processing",
                    };
                    var serverResponse = await dataService.downloadFileWithGet(
                      config.SERVICE_NAME_DELETEFILES +
                        "/" +
                        this.files.filesName[foundIndex].uid,
                    );
                    if (serverResponse.data) {
                      this.files.filesName.splice(foundIndex, 1);
                    } else {
                      Swal.fire(swal_option("warn", msg_code("wf007")));
                    }
                    this.loading_model = con_var.LOADING_MODEL;
                  }
                  this.files.filesName.push({
                    file_name: files[i].name,
                    uid: null,
                  });
                  this.files.selectedFiles.push(files[i]);
                }
              },
            );
          } else {
            this.files.filesName.push({ file_name: files[i].name, uid: null });
            this.files.selectedFiles.push(files[i]);
          }
        }
      }
      if (large_file) {
        Swal.fire(swal_option("warn", msg_code("wf010")));
      }
    },
    async download_files(uid, index) {
      this.loading_model = {
        process_loading: true,
        loading_text: "Dowloading",
      };
      let filename;
      if (index === null) {
        filename = this.files.img_name[this.files.img_name.length - 1];
      } else {
        filename = this.files.filesName[index].file_name;
      }
      var serverResponse = await dataService.downloadFileWithGet(
        config.SERVICE_NAME_DOWNLOADFILES + "/" + uid,
      );
      if (serverResponse.data) {
        const blob = new Blob([serverResponse.data]);
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = filename;
        link.click();
      } else {
        Swal.fire(swal_option("warn", msg_code("wf007")));
      }
      this.loading_model = con_var.LOADING_MODEL;
    },
    async delete_files(uid, index) {
      if (uid) {
        Swal.fire(swal_option("confirm", msg_code("cf011"))).then(
          async (result) => {
            if (result.isConfirmed) {
              this.loading_model = {
                process_loading: true,
                loading_text: "Processing",
              };
              var serverResponse = await dataService.downloadFileWithGet(
                config.SERVICE_NAME_DELETEFILES + "/" + uid,
              );
              if (serverResponse.data) {
                this.files.filesName.splice(index, 1);
              } else {
                Swal.fire(swal_option("warn", msg_code("wf007")));
              }
              this.loading_model = con_var.LOADING_MODEL;
            }
          },
        );
      } else {
        Swal.fire(swal_option("confirm", msg_code("cf010"))).then(
          async (result) => {
            if (result.isConfirmed) {
              this.files.selectedFiles.splice(index, 1);
              this.files.filesName.splice(index, 1);
            }
          },
        );
      }
    },
    /* Multi Data */
    async delete_job_tran_applicant(uid, index) {
      Swal.fire(swal_option("confirm", msg_code("cf005"))).then(
        async (result) => {
          if (result.isConfirmed) {
            this.delete_job_uid.push(uid);
            this.job_transactions_list.splice(index, 1);
          }
        },
      );
    },
    async addRow(type) {
      // Add row イベント
      var data = null;
      var check = true;
      var last_index = null;
      if (type === "license") {
        if (this.license_and_qualifications.length > 0) {
          last_index = this.license_and_qualifications.length - 1;
          data = this.license_and_qualifications[last_index];
          if (data.acquired_date && data.category && data.qualification) {
            this.error.license_and_qualifications[last_index] = {
              acquired_date: false,
              category: false,
              qualification: false,
            };
          } else {
            check = false;
            this.multiDataCheck(data, last_index, type);
          }
        }
        if (check) {
          this.license_and_qualifications.push({
            acquired_date: null,
            category: "",
            qualification: "",
            status: "",
          });
          this.error.license_and_qualifications.push({
            acquired_date: false,
            category: false,
            qualification: false,
            status: false,
          });
        }
      } else if (type === "education") {
        // 学歴新しい例追加
        if (this.education.length > 0) {
          last_index = this.education.length - 1;
          data = this.education[last_index];
          if (
            data.start_date &&
            data.end_date &&
            data.school &&
            data.edu_grade
          ) {
            this.error.education[last_index] = {
              start_date: false,
              end_date: false,
              school: false,
              edu_grade: false,
            };
          } else {
            check = false;
            this.multiDataCheck(data, last_index, type);
          }
        }
        if (check) {
          this.education.push({
            start_date: null,
            end_date: null,
            school: null,
            edu_grade: "",
          });
          this.error.education.push({
            start_date: false,
            end_date: false,
            school: false,
            edu_grade: false,
          });
        }
      } else if (type === "work_histories") {
        // 職歴新しい例追加
        if (this.work_histories.length > 0) {
          last_index = this.work_histories.length - 1;
          data = this.work_histories[last_index];
          if (
            data.start_date &&
            data.end_date &&
            data.organization &&
            data.position
          ) {
            this.error.work_histories[last_index] = {
              start_date: false,
              end_date: false,
              organization: false,
              position: false,
            };
          } else {
            check = false;
            this.multiDataCheck(data, last_index, type);
          }
        }
        if (check) {
          this.work_histories.push({
            start_date: null,
            end_date: null,
            organization: null,
            job_category_uid: "",
            position: null,
            monthly_salary: null,
          });
          this.error.work_histories.push({
            start_date: false,
            end_date: false,
            organization: false,
            job_type_uid: false,
          });
        }
      } else if (type === "family") {
        // 家族新しい例追加
        if (this.family_members.length > 0) {
          last_index = this.family_members.length - 1;
          data = this.family_members[last_index];
          if (data.name && data.relations) {
            this.error.family_members[last_index] = {
              name: false,
              relations: false,
            };
          } else {
            check = false;
            this.multiDataCheck(data, last_index, type);
          }
        }
        if (check) {
          this.family_members.push({
            name: null,
            relations: null,
            live_with: false,
            age: null,
            work_place: null,
            occupations: null,
          });
          this.error.family_members.push({ name: false, relations: false });
        }
      } else {
        Swal.fire(swal_option("error", msg_code("ef001")));
      }
    },
    async deleteRow(index, type) {
      // 削除イベント
      Swal.fire(swal_option("confirm", msg_code("cf004") + type + "?")).then(
        async (result) => {
          if (result.isConfirmed) {
            if (type == "license") {
              // 学歴例削除
              this.license_and_qualifications.splice(index, 1);
              this.error.license_and_qualifications.splice(index, 1);
            } else if (type == "education") {
              // 学歴例削除
              this.education.splice(index, 1);
              this.error.education.splice(index, 1);
            } else if (type == "work_histories") {
              // 昔職歴例削除
              this.work_histories.splice(index, 1);
              this.error.work_histories.splice(index, 1);
            } else if (type == "family") {
              // 家族例削除
              this.family_members.splice(index, 1);
              this.error.family_members.splice(index, 1);
            } else {
              Swal.fire(swal_option("error", msg_code("ef001")));
            }
          }
        },
      );
    },
    qualificationOptions(category) {
      return con_var.QUALIFICATION_OPTIONS[category] || [];
    },
    isLicenseStatusEnabled(category, qualification) {
      return (
        ["japanese", "ssw"].includes(category) &&
        qualification &&
        qualification !== "Other"
      );
    },
    normalizeLicenseRow(row) {
      const normalizedRow = { ...row };
      const parsed = this.splitLicenseQualification(
        normalizedRow.qualification,
      );
      normalizedRow.qualification = parsed.base;
      normalizedRow.status = parsed.status || "";
      return normalizedRow;
    },
    splitLicenseQualification(value) {
      if (!value || typeof value !== "string") {
        return { base: value || "", status: "" };
      }

      const match = value.match(/^(.*)\s+(Passed|Failed|Studying)$/);
      if (!match) {
        return { base: value, status: "" };
      }

      return {
        base: match[1].trim(),
        status: match[2],
      };
    },
    normalizeLicensePayload(rows) {
      return (rows || []).map((row) => {
        const normalizedRow = { ...row };
        const qualification = normalizedRow.qualification || "";
        if (
          this.isLicenseStatusEnabled(normalizedRow.category, qualification) &&
          normalizedRow.status
        ) {
          normalizedRow.qualification = `${qualification} ${normalizedRow.status}`;
        } else {
          normalizedRow.qualification = qualification;
        }
        delete normalizedRow.status;
        return normalizedRow;
      });
    },
    handleLicenseCategoryChange(row) {
      row.qualification = "";
      row.status = "";
    },
    handleLicenseQualificationChange(row) {
      if (!this.isLicenseStatusEnabled(row.category, row.qualification)) {
        row.status = "";
      }
    },
    /* 変数 */
    calculateAge() {
      // 生年月日イベント
      this.age = calculateAge(this.applicants.dob);
    },
    stateChange(fromInit = false) {
      if (!fromInit) {
        this.applicants.birth_city = "";
      }
      const state = this.drop_down.brithState.find(
        (s) => s.en === this.applicants.birth_state,
      );
      this.cityOptions = state ? con_var.CITY[state.id] : [];
    },
    validateHeight() {
      if (this.applicants.height < 0) {
        this.applicants.height = 0;
      }
    },
    validateWeight() {
      if (this.applicants.weight < 0) {
        this.applicants.weight = 0;
      }
    },
    handleInput(event) {
      const maxLength = this.max_length.height_weight;
      if (event.target.value.length >= maxLength) {
        event.preventDefault();
      }
    },
    handleEyeInput(event) {
      const maxLength = this.max_length.eyes;
      if (event.target.value.length >= maxLength) {
        event.preventDefault();
      }
    },
    /* データチャック */
    dataCheck() {
      var flg = true;
      var targetDiv = null;
      //名前チャック
      if (this.applicants.name_eng) {
        this.error.name_eng = false;
      } else {
        this.error.name_eng = true;
      }
      //生ま年月日チャック
      if (this.applicants.dob) {
        if (
          checkDate(this.applicants.dob) &&
          this.age > this.const_var.min_age &&
          this.age < this.const_var.max_age
        ) {
          this.error.dob = false;
          this.error.age = false;
        } else {
          this.error.dob = true;
          this.error.age = true;
        }
      } else {
        this.error.dob = true;
      }
      //city check
      if (this.applicants.birth_state && !this.applicants.birth_city) {
        this.error.birth_city = true;
      } else {
        this.error.birth_city = false;
      }
      //エラーチャックする。
      if (
        this.error.name_eng ||
        this.error.dob ||
        this.error.age ||
        this.error.birth_city
      ) {
        flg = false;
        targetDiv = this.$refs.app_info;
      }
      //学歴と職歴と家族データをチャックする。
      var data = null;
      for (let i = 0; i < this.license_and_qualifications.length; i++) {
        data = this.license_and_qualifications[i];
        this.multiDataCheck(data, i, "license");
        //エラーチャックする。
        if (
          this.error.license_and_qualifications[i].acquired_date ||
          this.error.license_and_qualifications[i].category ||
          this.error.license_and_qualifications[i].qualification ||
          this.error.license_and_qualifications[i].status
        ) {
          if (flg) {
            targetDiv = this.$refs.license_list;
            flg = false;
          }
        }
      }
      for (let i = 0; i < this.education.length; i++) {
        data = this.education[i];
        this.multiDataCheck(data, i, "education");
        //エラーチャックする。
        if (
          this.error.education[i].start_date ||
          this.error.education[i].end_date ||
          this.error.education[i].school ||
          this.error.education[i].edu_grade
        ) {
          if (flg) {
            targetDiv = this.$refs.edu_list;
            flg = false;
          }
        }
      }
      for (let i = 0; i < this.work_histories.length; i++) {
        data = this.work_histories[i];
        this.multiDataCheck(data, i, "work_histories");
        //エラーチャックする。
        if (
          this.error.work_histories[i].start_date ||
          this.error.work_histories[i].end_date ||
          this.error.work_histories[i].organization ||
          this.error.work_histories[i].position
        ) {
          if (flg) {
            targetDiv = this.$refs.work_his;
            flg = false;
          }
        }
      }
      for (let i = 0; i < this.family_members.length; i++) {
        data = this.family_members[i];
        this.multiDataCheck(data, i, "family");
        //エラーチャックする。
        if (
          this.error.family_members[i].name ||
          this.error.family_members[i].relations
        ) {
          if (flg) {
            targetDiv = this.$refs.family_member;
            flg = false;
          }
        }
      }
      //パスポート日チャック
      if (this.applicants.passport_exp_date) {
        if (checkDate(this.applicants.passport_exp_date)) {
          this.error.passport_exp_date = false;
        } else {
          this.error.passport_exp_date = true;
        }
      } else {
        this.error.passport_exp_date = false;
      }
      //申し込み日チャック
      if (this.applicants.apply_date) {
        if (checkDate(this.applicants.apply_date)) {
          this.error.apply_date = false;
        } else {
          this.error.apply_date = true;
        }
      } else {
        this.error.apply_date = false;
      }
      //エラーチャックする。
      if ((this.error.passport_exp_date || this.error.apply_date) && flg) {
        flg = false;
        targetDiv = this.$refs.other_info;
      }
      if (!flg) {
        this.loading_model = con_var.LOADING_MODEL;
        targetDiv.scrollIntoView({ behavior: "smooth" });
        this.applicants = dropdownSelect(this.applicants, "applicant");
        for (let i = 0; i < this.work_histories.length; i++) {
          this.work_histories[i] = dropdownSelect(
            this.work_histories[i],
            "work",
          );
        }
      }
      return flg;
    },
    multiDataCheck(data, i, type) {
      if (type === "license") {
        if (data.acquired_date && checkDateYM(data.acquired_date)) {
          this.error.license_and_qualifications[i].acquired_date = false;
        } else {
          this.error.license_and_qualifications[i].acquired_date = true;
        }
        if (data.category) {
          this.error.license_and_qualifications[i].category = false;
        } else {
          this.error.license_and_qualifications[i].category = true;
        }
        if (data.qualification) {
          this.error.license_and_qualifications[i].qualification = false;
        } else {
          this.error.license_and_qualifications[i].qualification = true;
        }
        if (this.isLicenseStatusEnabled(data.category, data.qualification)) {
          if (data.status) {
            this.error.license_and_qualifications[i].status = false;
          } else {
            this.error.license_and_qualifications[i].status = true;
          }
        } else {
          this.error.license_and_qualifications[i].status = false;
        }
      } else if (type === "education") {
        if (data.start_date && checkDateYM(data.start_date)) {
          this.error.education[i].start_date = false;
        } else {
          this.error.education[i].start_date = true;
        }
        if (data.end_date && checkDateYM(data.end_date)) {
          this.error.education[i].end_date = false;
        } else {
          this.error.education[i].end_date = true;
        }
        if (data.school) {
          this.error.education[i].school = false;
        } else {
          this.error.education[i].school = true;
        }
        if (data.edu_grade) {
          this.error.education[i].edu_grade = false;
        } else {
          this.error.education[i].edu_grade = true;
        }
      } else if (type === "work_histories") {
        if (data.start_date && checkDateYM(data.start_date)) {
          this.error.work_histories[i].start_date = false;
        } else {
          this.error.work_histories[i].start_date = true;
        }
        if (data.end_date && checkDateYM(data.end_date)) {
          this.error.work_histories[i].end_date = false;
        } else {
          this.error.work_histories[i].end_date = true;
        }
        if (data.organization) {
          this.error.work_histories[i].organization = false;
        } else {
          this.error.work_histories[i].organization = true;
        }
        if (data.position) {
          this.error.work_histories[i].position = false;
        } else {
          this.error.work_histories[i].position = true;
        }
      } else if (type === "family") {
        if (data.name) {
          this.error.family_members[i].name = false;
        } else {
          this.error.family_members[i].name = true;
        }
        if (data.relations) {
          this.error.family_members[i].relations = false;
        } else {
          this.error.family_members[i].relations = true;
        }
      } else {
        Swal.fire(swal_option("error", msg_code("ef001")));
      }
    },
    async reset() {
      this.age = null;
      this.nrc = con_var.REG_NRC;
      this.applicants = con_var.DEFAULT_APPLICANT;
      this.job_transactions = {};
      this.job_transactions_list = [];
      this.delete_job_uid = [];
      this.change_file_uid = [];
      this.education = [];
      this.license_and_qualifications = [];
      this.work_histories = [];
      this.family_members = [];
      this.selectedCountries = [];
      this.selectedLanguages = [];
      this.cityOptions = [];
      this.applicants = {
        gender: "M",
        has_refer: 0,
        recruited_from: "",
        medical_check: 0,
        smoking: 0,
        drinking: 0,
        handedness: "R",
        blood_type: "",
        religion: "",
        passport_type: "",
        marital_status: "S",
        interview_status: "",
      };
      this.files = {
        profile_update: false,
        img_uid: null,
        img_name: null,
        profile: null,
        profileURL: null,
        selectedFiles: [],
        filesName: [],
      };
      this.error = {
        name_eng: false,
        dob: false,
        age: false,
        passport_exp_date: false,
        apply_date: false,
        license_and_qualifications: [],
        education: [],
        work_histories: [],
        family_members: [],
      };
      this.loading_model = con_var.LOADING_MODEL;
      this.$router.push({ name: "applicantRegister" });
    },
  },
};
</script>
